import { defineStore } from 'pinia'
import { ref } from 'vue'

const STORAGE_KEY = 'worksome-ai-consent'

export const useAiConsentStore = defineStore('ai-consent', () => {
  const hasConsent = ref(false)
  const isInitialized = ref(false)

  const initialize = () => {
    if (isInitialized.value) {
      return
    }

    const storedConsent = localStorage.getItem(STORAGE_KEY)
    const serverConsent = currentUser?.ai_consent ?? false

    if (serverConsent) {
      hasConsent.value = true
      if (storedConsent !== 'true') {
        localStorage.setItem(STORAGE_KEY, 'true')
      }
    } else {
      hasConsent.value = false
      if (storedConsent) {
        localStorage.removeItem(STORAGE_KEY)
      }
    }

    isInitialized.value = true
  }

  const grantConsent = () => {
    hasConsent.value = true
    localStorage.setItem(STORAGE_KEY, 'true')
  }

  const revokeConsent = () => {
    hasConsent.value = false
    localStorage.removeItem(STORAGE_KEY)
  }

  return {
    hasConsent,
    initialize,
    grantConsent,
    revokeConsent,
  }
})
